"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** A map of ISO 4217 Currency Codes to the Symbols those currencies use. */
const currencies = {
    'USD': '$',
    'CAD': '$',
    'MXN': '$',
    'GBP': '£',
    'EUR': '€',
    'JPY': '¥',
    'CNY': '¥',
};
exports.default = currencies;
//# sourceMappingURL=Currencies.js.map